import { FC } from 'react';
import { Image } from '@chakra-ui/react';

import OBFileItem from 'features/Onboarding/components/OBFileItem';
import TreezorUpload, {
  FILE_TYPE,
  UploadMessage,
} from 'features/Onboarding/legacy/components/TreezorUpload';

import Clipboard from './assets/Clipboard@2x.png';
import { UploadWrapper } from './styles';
import { DisplayOrUploadDocProps } from './types';

const DisplayOrUploadDoc: FC<DisplayOrUploadDocProps> = ({
  existingDocumentUrl,
  isDeletingExistingDocument,
  locales,
  onDeleteExistingDocument,
  onSuccessfulUpload,
  uploadFile,
}) => {
  if (existingDocumentUrl !== undefined) {
    return (
      <OBFileItem
        fileName={locales.uploadedDocumentName}
        isLoading={isDeletingExistingDocument}
        onDeleteClick={onDeleteExistingDocument}
        onPreviewClick={() => window.open(existingDocumentUrl, '_blank')}
      />
    );
  }

  return (
    <UploadWrapper>
      <TreezorUpload
        errorMessage={locales.uploadFailureMessage}
        fileTypes={FILE_TYPE.ALLOWED_DOCUMENTS}
        onSuccessfulUpload={onSuccessfulUpload}
        uploadFile={uploadFile}
      >
        <UploadMessage
          dragAndDropMessage={locales.uploadFormDragDrop}
          imageElement={<Image boxSize="120px" src={Clipboard} />}
        />
      </TreezorUpload>
    </UploadWrapper>
  );
};

export default DisplayOrUploadDoc;
